module.exports = __webpack_public_path__ + "img/Mathethon.98d492e8.png";